import { NgModule } from '@angular/core';
import { AgGridModule } from 'ag-grid-angular';
import { WeissmanSharedModule } from '../../Common/weissman-shared.module';
import { AgGridExtensionsModule } from '../../Compliance/AgGrid/agGridExtensions.module';
import { DirectivesModule } from '../../UI-Lib/Directives/directives.module';
import { PaymentApprovalModule } from '../../Payment-Batch/Approval/paymentApproval.module';
import { ActionViewComponent } from './actionView.component';
import { ActionDetailedComponent } from './Detailed-List/actionDetailed.component';
import { ActionViewDateCriteriaComponent } from './Filters/actionViewDateCriteria.component';
import { ActionViewOverviewOptionsComponent } from './Filters/actionViewOverviewOptions.component';
import { ActionViewTaskCriteriaComponent } from './Filters/actionViewTaskCriteria.component';
import { MultiUserTeamPickerComponent } from './Filters/Multi-User-Team-Picker/multiUserTeamPicker.component';
import { ActionViewOverviewComponent } from './Overview/actionViewOverview.component';
import { ActionViewSaveComponent } from './Save/actionViewSave.component';

@NgModule({
    imports: [
        WeissmanSharedModule,
        DirectivesModule,
        AgGridExtensionsModule,
        AgGridModule,
        MultiUserTeamPickerComponent,
        PaymentApprovalModule,
    ],
    declarations: [
        ActionViewComponent,
        ActionViewDateCriteriaComponent,
        ActionViewOverviewComponent,
        ActionViewOverviewOptionsComponent,
        ActionViewSaveComponent,
        ActionViewTaskCriteriaComponent,
        ActionDetailedComponent,
    ],
    exports: [],
})
export class ActionViewModule {
    static setupModule(): void {}
}
